import { render, staticRenderFns } from "./emptyRecommendation.html?vue&type=template&id=7ff31880&scoped=true&"
import script from "./emptyRecommendation.vue?vue&type=script&lang=js&"
export * from "./emptyRecommendation.vue?vue&type=script&lang=js&"
import style0 from "./emptyRecommendation.vue?vue&type=style&index=0&id=7ff31880&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff31880",
  null
  
)

export default component.exports